export default __webpack_public_path__ + "static/media/thabit.e1c3bf8c.svg";